import { render, staticRenderFns } from "./CfgEmpresa.vue?vue&type=template&id=a6cefd82&scoped=true&"
import script from "./CfgEmpresa.vue?vue&type=script&lang=js&"
export * from "./CfgEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cefd82",
  null
  
)

export default component.exports